function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.45275 1C7.45275 0.585786 7.78854 0.25 8.20275 0.25H11.8027C12.217 0.25 12.5527 0.585786 12.5527 1V5.91667H14.2028C14.5009 5.91667 14.7707 6.09327 14.8901 6.36649C15.0094 6.63972 14.9555 6.95768 14.7529 7.17638L10.5529 11.7097C10.411 11.8629 10.2116 11.95 10.0027 11.95C9.7939 11.95 9.59452 11.8629 9.45258 11.7097L5.25258 7.17638C5.04995 6.95768 4.99611 6.63972 5.11544 6.36649C5.23477 6.09327 5.5046 5.91667 5.80275 5.91667H7.45275V1Z",
  fill: "#767B87"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.2 1.75C1.91085 1.75 1.75 1.96176 1.75 2.13333V16.8667C1.75 17.0382 1.91085 17.25 2.2 17.25H17.8C18.0892 17.25 18.25 17.0382 18.25 16.8667V2.13333C18.25 1.96176 18.0892 1.75 17.8 1.75H15.4C14.9858 1.75 14.65 1.41421 14.65 1C14.65 0.585786 14.9858 0.25 15.4 0.25H17.8C18.8356 0.25 19.75 1.05371 19.75 2.13333V16.8667C19.75 17.9463 18.8356 18.75 17.8 18.75H2.2C1.16435 18.75 0.25 17.9463 0.25 16.8667V2.13333C0.25 1.05371 1.16435 0.25 2.2 0.25H4.6C5.01421 0.25 5.35 0.585786 5.35 1C5.35 1.41421 5.01421 1.75 4.6 1.75H2.2Z",
  fill: "#767B87"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 16C1 14.8954 1.30996 14 1.69231 14H18.3077C18.69 14 19 14.8954 19 16C19 17.1046 18.69 18 18.3077 18H1.69231C1.30996 18 1 17.1046 1 16Z",
  fill: "#767B87"
});

const SvgDownloadPdfSolid = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgDownloadPdfSolid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download_pdf_solid.73a266bc.svg";
export { ForwardRef as ReactComponent };